import React, { useState, useRef, useEffect, useCallback } from 'react';
import isEqual from 'lodash/isEqual';
import {filter, isEmpty, isUndefined} from 'lodash';
import { isWeiXinMiniProgram } from './fileType';

//工具类
const getServiceLangCode = (i18n) => {
  return (i18n?.language==='zh-CN'?'zh':i18n?.language)??'zh';
};
const getProductImg = (prod) => {
  return prod.mime === null ? null : filter(prod.mime, { mimePurpose: 'thumbnail' })?.[0]?.['mimeSource']?.[0]?.['#text'];
};
const getValueByLanguage = (i18n, value) => {
  if (!i18n) {
    return (typeof value === 'string' ? value : (value?.['zh']??''));
  }
  const local = getServiceLangCode(i18n);
  if (isUndefined(value))
    return value;
  return (typeof value === 'string' ? value : (value?.[local] ?? ''));
};
function openNewTabByA(hrefValue) {
  const link = window.document.createElement('a');
  let decodedHref = '';
  try {
    decodedHref = decodeURIComponent(hrefValue);
  } catch (e) {
    decodedHref = decodeURI(hrefValue);
  }
  link.href = decodedHref;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';
  window.document.body.appendChild(link);
  link.click();
  window.document.body.removeChild(link);
}
const openSFUrl = (url) => {
  //window.parent?.location.href = url;
  window?.open(url, '_blank');
};
const openSFUrlCurrentWindow = (url) => {
  window.location.href = url;
};
const queryParse = (query) => {
  query = query.substring(query.indexOf('?') + 1);
  const array = query.split('&');
  const params = {};
  array.forEach(item => {
    const key = item.substring(0, item.indexOf('='));
    if (key.length===0)
      return;
    const value = decodeURIComponent(item.substring(item.indexOf('=') + 1));
    params[key] = value;
  });
  return params;
};
const appendUrlParameter =(url, key, value) => {
  const querys = queryParse(url);
  const hasQuery = !isEmpty(querys);
  const separator = hasQuery? '&' : '?';
  const newQuery = `${key}=${encodeURIComponent(value)}`;
  return `${url}${separator}${newQuery}`;
};

const saveToContact = (name, phone, remark = '',messageCenter=null) => {
  const ua = window.navigator.userAgent.toLowerCase();

  const isWeixin1 = ua.indexOf('micromessenger') != -1;
  if (isWeixin1 && !isWeiXinMiniProgram()) {

    if (messageCenter) {
      messageCenter.sendMessage('MESSAGE_POP_MADSK', {open:true, vcard:{name:name, phone:phone}});
    }
    // copy(url+'?attname='+name);
    return false;
  }
  // 1. 生成符合vCard 3.0标准的内容（严格遵循格式，否则无法解析）
  const vCardContent = `BEGIN:VCARD
VERSION:3.0
N:;${name};;;
FN:${name}${remark ? '(' + remark + ')' : ''}
TEL;TYPE=CELL,VOICE:${phone}
REV:${new Date().toISOString()}
END:VCARD`;

  // 2. 将字符串转为Blob二进制对象（指定vcf文件类型）
  const blob = new Blob([vCardContent], { type: 'text/vcard;charset=utf-8' });
  // 生成临时下载链接
  const url = URL.createObjectURL(blob);

  // 3. 创建隐藏a标签，触发浏览器下载
  const a = document.createElement('a');
  a.href = url;
  a.download = `${name}.vcf`; // 文件名以姓名命名，后缀必须为.vcf
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click(); // 触发下载

  // 4. 清理资源，避免内存泄漏
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
const callPhone = (phoneNumber) => {
  // 拼接tel协议链接：tel: + 纯数字手机号（无空格/横线）
  const telUrl = `tel:${phoneNumber}`;
  // 创建隐藏a标签，触发点击（兼容所有浏览器）
  const a = document.createElement('a');
  a.href = telUrl;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click(); // 唤起系统拨号界面
  document.body.removeChild(a); // 清理节点
}
const Utills = {getServiceLangCode,
  getValueByLanguage,
  openNewTabByA,
  getProductImg,
  openSFUrl,
  appendUrlParameter,
  openSFUrlCurrentWindow,
  saveToContact,
  callPhone
};
export default Utills;
